var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 4c4.775 0 8.5 3.967 8.5 8.5S16.657 21 12.5 21 4 17.033 4 12.5 7.725 4 12.5 4m0 0v17m0-17q3.771 1.938 3.772 8.5T12.5 21m0-17q-4.157 1.726-4.157 8.5 0 6.775 3.874 8.5M4.445 9.967h16.022M4.591 15.033h15.815"
  })));
};
export default SvgGlobe;